export default function BandeauUrgence() {
  return (
    <section id="dépannage-urgence" className="bg-brand-light py-10 md:py-14">
      <div className="max-w-3xl mx-auto px-4 md:px-8 text-center">
        <h2 className="text-brand-blue text-lg md:text-2xl font-bold mb-3">
          <strong className="text-brand-blue">Volet roulant bloqué</strong> ? Qui ne remonte plus ?
        </h2>
        <p className="text-brand-text text-base md:text-lg leading-relaxed mb-6 max-w-2xl mx-auto">
          Nos techniciens interviennent en urgence partout à Strasbourg, sur volet manuel comme électrique.
        </p>
        <a
          href="tel:0374473240"
          className="flex items-center justify-center gap-2 bg-brand-cyan text-white px-5 md:px-7 py-3.5 rounded-full font-semibold text-sm md:text-base hover:bg-brand-cyan/90 transition-all duration-200 btn-hover-effect mx-auto"
        >
          Dépannage immédiat — 03 74 47 32 40
          <span className="btn-icon-wrap"><i className="ri-arrow-right-line text-lg"></i></span>
        </a>
      </div>
    </section>
  );
}